export default "__VITE_ASSET__Dfa2GtE6__"